<template>
<span>
    <span v-if="internalValue && internalValue.length > 0">
        <div v-for="item in internalValue" :key="item.index">
            <span class="fa fa-times-circle" title="Remove File" style="color: red; cursor: pointer;" @click="clearFiles"></span>
            <span :title="item.name">{{item.name.length > 15 ? item.name.slice(0, 15) + "..." : item.name}}</span>
        </div>
    </span>
    <label v-else :class="['btn', buttonClass, { error: hasError }]" style="margin-bottom: 0;">
        <i class="fa fa-upload mr-2" /> {{ name }} <input type="file" ref="uploader" style="display: none;" @change="onFileSelect" />
    </label>
    <div class="error-div" style="margin-top: 0;">
        {{validationMessage}}
    </div>
</span>
</template>

<script>
import primitiveMixin from './primitive-mixin'
import { v } from "framework";

export default {
    mixins: [primitiveMixin],
    props: {
        value: { required: true },
        buttonClass: { type: String, required: false, default: "btn-success" },
        name: { type: String, required: false, default: 'Upload File' },
    },
    data() {
        return {
            internalValue: this.copyObject(this.value),
        };
    },
    methods: {
        clearFiles() {
            this.internalValue = [];
        },
        copyObject(val){
            return val;
        },
        async onFileSelect(e) {
            this.internalValue = e.target.files || e.dataTransfer.files;
            console.log("NameChange onFileSelect selectedFile: ", this.copyObject(this.internalValue));
        }
    },
    watch: {
        value(newValue) {
            this.internalValue = this.copyObject(newValue);
        },
        internalValue(newValue) {
            this.changeMade({
                name: this.label,
                value: this.copyObject(this.internalValue),
            });
            if (newValue === "" || newValue === null) {
                this.$emit("input", null);
            } else {
                this.$emit("input", this.copyObject(newValue));
            }
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/framework/primitives/AmfNameChange.vue